const translations = {
    buttonText: 'Delete',
    confirmDelete: 'Delete Flight Report?',
    confirmDeleteMessage: 'Are you sure you want to delete this flight report?'
};

export default translations;
